// -------------- Hook to call the api endpoint for the SHAP values ---------------
// ----------------------------------------------------------------------------------
// import functions and service
import { useState, useCallback } from 'react';
import { getSHAPValues } from '../services/api';

// hook used to fetch SHAP values from the backend API
export const useSHAPValues = () => {

  // set all the states for the frontend to handle
  const [shapData, setShapData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // callback function to run the API request to the backend and handle the response
  const loadSHAP = useCallback(async ({ model, n_explain = 2000 }) => {
    
    // set the state to loading
    setLoading(true);
    setError(null);
    setShapData(null);


    try {
      const data = await getSHAPValues({ model, n_explain });
      setShapData(data); // run the APi call and set the shap data

    } catch (err) {
      console.error('Error loading SHAP values:', err);
      setError(err.message || 'Failed to load SHAP values');

    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setShapData(null);
    setError(null);
  }, []); // reset function to clear the shap data and error states

  return { shapData, loading, error, loadSHAP, reset }; // return the states and functions to the frontend
};
